import React, { useState } from 'react';
import { InputField } from '../../components/InputField';
import { Section, SectionTitle } from '../../components/TwoColumnLayout';
import { isNotEmpty } from '../../utils/validator';
import styled from 'styled-components';

interface Props {
	firstName: string;
	lastName: string;
	costCenterName: string;
	costCenterAddress: string;
	simClientInfoChangeHandler: (field: string, value: string) => void;
	disabled: boolean;
}

const ErrorMessage = styled.div`
	color: red;
`;

export const BusinessCustomerForm: React.FC<Props> = (props: Props) => {
	const [showFirstNameError, setShowFirstNameError] = useState<boolean>(false);
	const [showLastNameError, setShowLastNameError] = useState<boolean>(false);

	const userNameChange = (field: string, value: string) => {
		const notEmpty: boolean = isNotEmpty(value);
		if (notEmpty) {
			props.simClientInfoChangeHandler(field, value);
		}
		if (field === 'sim-customer-first-name') {
			setShowFirstNameError(!notEmpty);
		} else {
			setShowLastNameError(!notEmpty);
		}
	};

	return (
		<React.Fragment>
			<SectionTitle>Käyttäjän tiedot</SectionTitle>
			<Section>
				<form style={{padding: "1rem"}}>
					<InputField title={'Etunimi'} field={'sim-customer-first-name'} value={props.firstName} onChange={userNameChange} disabled={props.disabled} />
					{showFirstNameError && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					<InputField title={'Sukunimi'} field={'sim-customer-last-name'} value={props.lastName} onChange={userNameChange} disabled={props.disabled} />
					{showLastNameError && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					<InputField title={'Kustannuspaikka'} field={'sim-customer-cost-center-name'} value={props.costCenterName} onChange={props.simClientInfoChangeHandler} disabled={props.disabled} />
					<InputField
						title={'Kustannuspaikan osoite'}
						field={'sim-customer-cost-center-address'}
						value={props.costCenterAddress}
						onChange={props.simClientInfoChangeHandler}
						disabled={props.disabled}
					/>
				</form>
			</Section>
		</React.Fragment>
	);
};
